import React, { useContext } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { useDeps } from 'src/hooks/useDeps';

import { Svg } from '../Svg/Svg';

import classes from './HeaderControls.scss';
import { ConnectedBasketIcon } from './BasketIcon';
import { AccountIcon } from './AccountIcon';
import { HeaderContext } from './Header';

export const HeaderControls = React.memo(function HeaderControls() {
    const { showNav, setShowNav } = useContext(HeaderContext);
    const { paths } = useDeps();

    return (
        // New icon for Community. Hidden below 400px.
        <ul className={classes.headerControls}>
            <li>
                <Link
                    to={paths.community.joinCommunity}
                    className={classnames({
                        [classes.headerControl]: true,
                        [classes.headerControlCommunity]: true,
                    })}
                >
                    <Svg name="community-icon" aria-hidden={true} />
                    <span className={classes.headerControlContent}>
                        Join our
                        <br /> Community
                    </span>
                </Link>
            </li>
            <li>
                <Link
                    data-test-id="HeaderControls__TipsAndAdvice"
                    to="/click-collect"
                    className={classnames({
                        [classes.headerControl]: true,
                        [classes.headerControlTips]: true,
                    })}
                >
                    <Svg name="click-collect" aria-hidden={true} />
                    <span className={classes.headerControlContent}>
                        Click &<br /> Collect
                    </span>
                </Link>
            </li>
            <li>
                <Link
                    to={paths.storeLocator.storeLocator}
                    className={classnames({
                        [classes.headerControl]: true,
                        [classes.headerControlContact]: true,
                    })}
                >
                    <Svg name="place" aria-hidden={true} />
                    <span className={classes.headerControlContent}>Stores</span>
                </Link>
            </li>
            <li>
                <AccountIcon />
            </li>
            <li>
                <ConnectedBasketIcon />
            </li>
            <li>
                <button
                    data-test-id="menu-trigger"
                    className={classnames({
                        [classes.headerControl]: true,
                        [classes.headerControlMenu]: true,
                        [classes.headerControlMenuActive]: showNav,
                    })}
                    onClick={() => {
                        setShowNav(!showNav);
                    }}
                    type="button"
                    aria-expanded={showNav}
                    aria-haspopup="menu"
                    aria-controls="main-navigation"
                >
                    {!showNav && <Svg name="menu" aria-hidden="true" />}
                    {showNav && <Svg name="close" aria-hidden="true" />}
                    <span className={classes.headerControlContent}>{showNav ? 'Close' : 'Menu'}</span>
                </button>
            </li>
        </ul>
    );
});
